/**
 * Séparateur de milliers écrit à la main plutôt que `toLocaleString` : l'ICU de
 * Node (SSR) et celle du navigateur ne rendent pas toujours le même espace en
 * français, et la moindre différence casse l'hydratation.
 */
export function groupThousands(value: number, separator: string): string {
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}
